<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>{{ 'EMAIL_SETTINGS.TITLE' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <email-domain-authorization
      [senderType]="SenderTypePartner"
      [senderID]="partnerId$ | async"
    ></email-domain-authorization>
  </glxy-page-wrapper>
</glxy-page>
